import { all, put, select, takeLatest } from "redux-saga/effects";
import { it, en } from "../../intl";
import { getConfig } from "../configuration";
import {
  GET_LOCALE_INFO,
  SET_LOCALE,
  FETCH_MESSAGES,
  IT,
  EN,
  fetchMessagesSuccess,
  setLocale,
  getMessages,
  fetchMessages,
  editLocaleInfo,
  geoPluginMock,
} from "./index";

function* getLocaleWorker() {
  let locale = IT;
  try {
    const response = geoPluginMock;
    if (response.status === 200) locale = response;
    else throw response.message;
  } catch (e) {
    console.error("Errore durante il recupero del country code:", e);
    const config = yield select(getConfig);
    if (config.defaultLanguage && config.defaultLanguage !== undefined) locale = config.defaultLanguage;
  } finally {
    yield put(setLocale(editLocaleInfo(locale)));
  }
}

function* setLocaleWorker(action) {
  const locale = action.locale.countryCode;
  try {
    const messages = yield select(getMessages);
    if (messages === undefined) yield put(fetchMessages(locale));
  } catch (e) {
    console.error("Errore durante il set della lingua:", e);
  }
}

function* fetchMessagesWorker(action) {
  const locale = action.locale;
  try {
    if (locale === IT) yield put(fetchMessagesSuccess(locale, it));
    if (locale === EN) yield put(fetchMessagesSuccess(locale, en));
  } catch (e) {
    console.error("Errore durante il caricamento del dizionario:", e);
  }
}

function* getLocaleWatcher() {
  yield takeLatest(GET_LOCALE_INFO, getLocaleWorker);
}

function* setLocaleWatcher() {
  yield takeLatest(SET_LOCALE, setLocaleWorker);
}

function* fetchMessagesWatcher() {
  yield takeLatest(FETCH_MESSAGES, fetchMessagesWorker);
}

export function* languageWatchers() {
  yield all([getLocaleWatcher(), setLocaleWatcher(), fetchMessagesWatcher()]);
}
